/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        rightFar:   hsl(30, 13, 37),
        right:      hsl(30, 13, 42),
        leftFar:    hsl(30, 13, 42),
        left:       hsl(30, 13, 47),
        edge:       hsl(30, 13, 72),
        face:       hsl(30, 13, 82),

        background: hsl(160, 23, 47),

        edgeNew:    hsl(200, 35, 62),
        faceNew:    hsl(200, 35, 72),

        edgeMoved:  hsl(320, 20, 62),
        faceMoved:  hsl(320, 20, 72),
    },
}
